<div class="app-router no-scroll">
  <app-terms-and-conditions-template [domainName]="domainName" [isOpenUrl]="false" (tncScrollEvent)="onTncScroll($event)"></app-terms-and-conditions-template>
  <div class="dark-bg-info-card-base floating-footer">
    <div class="cp-checkbox-default float-right">
      <div class="form-check has-success">
        <input [attr.disabled]="tncDisabled ? true : null"  type="checkbox" name="tnc-checkbox" id="tnc-checkbox" class="form-check-input" (change)="onTncChange($event)">
        <label class="form-check-label success-text highlight-text" for="tnc-checkbox">
          <span class="warning-text" [hidden]="!tncDisabled">Please read the terms and conditions to accept.</span>
          <span [hidden]="tncDisabled">I understand and accept the Terms and Conditions.</span>
        </label>
      </div>
    </div>
    <div>
      <a class="text-right float-left cp-hyperlink cursor-pointer" (click)="logoutAndGoToLogin()">I do not accept.</a>
    </div>
  </div>
